import { ApiError } from "./client";

/**
 * Codice d'errore del backend → chiave i18n. Il backend dei pagamenti manda un
 * codice leggibile (`detail.code`): il messaggio dice al cliente cosa è
 * successo DAVVERO. Prima ogni 409 diventava «già pagato», anche per un ordine
 * annullato o in elaborazione, e ogni 503 «non disponibile» (R-76).
 */
const BY_CODE: Record<string, string> = {
  online_payment_disabled: "checkout.errors.notConfigured",
  stripe_not_configured: "checkout.errors.notConfigured",
  return_urls_not_configured: "checkout.errors.notConfigured",
  already_paid: "checkout.errors.alreadyPaid",
  order_cancelled: "checkout.errors.cancelled",
  not_payable: "checkout.errors.notPayable",
  invalid_total: "checkout.errors.notPayable",
  payment_on_hold: "checkout.errors.onHold",
  payment_processing: "checkout.errors.processing",
  attempt_in_progress: "checkout.errors.inProgress",
  provider_unavailable: "checkout.errors.provider",
  provider_rejected: "checkout.errors.provider",
  amount_below_minimum: "checkout.errors.amountMin",
  amount_above_maximum: "checkout.errors.amountMax",
  checkout_mode_mismatch: "checkout.errors.modeChanged",
  checkout_client_outdated: "checkout.errors.outdated",
  idempotency_conflict: "checkout.errors.conflict",
  order_not_found: "checkout.errors.notFound",
  invalid_order_id: "checkout.errors.notFound",
};

// Mappa un errore (di checkout/pagamento) a una chiave i18n localizzata, così al
// cliente non appare mai una stringa tecnica del backend.
export function paymentErrorKey(err: unknown): string {
  if (err instanceof ApiError) {
    const byCode = err.code ? BY_CODE[err.code] : undefined;
    if (byCode) return byCode;
    switch (err.status) {
      case 503:
        return "checkout.errors.notConfigured";
      case 409:
        return "checkout.errors.notPayable";
      case 404:
        return "checkout.errors.notFound";
      case 502:
        return "checkout.errors.provider";
      case 400:
        return "checkout.errors.cart";
      case 429:
        // Limite di frequenza del server: non è un errore del pagamento.
        return "checkout.errors.rateLimited";
      default:
        return "checkout.errors.generic";
    }
  }
  // fetch fallisce con TypeError su errore di rete (prima di ApiError).
  return "checkout.errors.network";
}
